import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/invoices',
  title: 'Financeiros',
  endpoint: '/app/expedition/order',
  breadcrumbs: [],
}
